<template>
  <div id="header">
    <div class="container py-2">
      <img src="../assets/su.svg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>
